import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const StyledContactName = styled(Text)`
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	color: #ffffff;
	transition: opacity 0.3s ease;
	height: 16px;
	margin-top: 40px;
	opacity: 0.25;
`;

const StyledNumber = styled(Text)`
	font-weight: 500;
	font-size: 30px;
	text-align: center;
	color: #ffffff;
	margin-top: 20px;
	height: 34px;
`;

const StyledTime = styled(Text)`
	font-weight: 500;
	font-size: 18px;
	text-align: center;
	color: #ffffff;
	margin-top: 20px;
`;

const StyledButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	background-color: #a82f31;
	border-radius: 60px;
	transition: background-color 0.3s ease;
	cursor: pointer;
	margin-top: 265px;

	&:hover {
		background-color: #a82f31;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: opacity 0.3s ease;
		transform: rotate(135deg);
	}
`;

export {
	StyledButton,
	StyledContactName,
	StyledContainer,
	StyledNumber,
	StyledTime,
};
